/**
 * @typedef {'left' | 'right' | 'up' | 'down'} IconChevronDirections
 */

export const ICON_CHEVRON_DIRECTION = {
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up',
}
